module.exports = __webpack_public_path__ + "static/media/upload_more.027a5b3e.svg";